import { EndpointKey } from '../http/EndpointKey';
import { isEndOfUserOnlyFlow } from '../store/flow/selectors';
import { isEndpointStatusSuccess, isSignupCompletedFired } from '../store/http-responses/selectors';
export const userOnlyFlowOverrideRedirectCheck = state => {
  const isEndOfUserOnlyFlowCheck = isEndOfUserOnlyFlow(state);
  const isSignupEndpointSuccessful = isEndpointStatusSuccess(EndpointKey.Signup)(state);
  const isLoginNewPortalEndpointSuccessful = isEndpointStatusSuccess(EndpointKey.LoginNewPortal)(state);
  const signupCompletedFiredCheck = isSignupCompletedFired(state);
  return signupCompletedFiredCheck && isEndOfUserOnlyFlowCheck && isSignupEndpointSuccessful && isLoginNewPortalEndpointSuccessful;
};